export default __webpack_public_path__ + "static/media/ElipseYellow.77dd1591.svg";